/**
 * Ticket redmine associé temporairement. En attente des modification back du getProperty
 * https://projets2.afidium.com/issues/22008
 */

// Angular
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ITelephone } from "libraries/interfaces/itelephone.interface";

import {faFax, faPhone, faMobile, IconDefinition, faInfo} from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'telephone',
    template: `
        <div class="telephone">
            <fa-icon [icon]="telephoneIcon" class="icon" [class.fa-mobile]="telephoneIcon == iconMobile"></fa-icon>
            {{ valueToDisplay }}
        </div>
    `,
    styles: [`
        .telephone {
            display: flex;
            align-items: center;
        }

        .fa-mobile {
            font-size: 1.3rem;
        }

        .icon {
            width: 18px;
        }
    `]
})
export class TelephoneComponent implements OnChanges {
    @Input()
    public telephone: ITelephone;

    public telephoneIcon: IconDefinition = faPhone;

    public valueToDisplay: string;

    public iconFax: IconDefinition = faFax;
    public iconPhone: IconDefinition = faPhone;
    public iconMobile: IconDefinition = faMobile;
    public iconHelp: IconDefinition = faInfo;

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.telephone && changes.telephone.currentValue) {
            this.valueToDisplay = this.telephone.text || this.telephone.number;
            const type: string = (this.telephone.xType || this.telephone.type || "").toLowerCase();
            switch (type) {
                case 'fax':
                    this.telephoneIcon = this.iconFax;
                    break;
                case 'mobile':
                    this.telephoneIcon = this.iconMobile;
                    break;
                case 'fixed':
                    this.telephoneIcon = this.telephone.xScope === 'HelpDesk' ? this.iconHelp : this.iconPhone;
                    break;
                default:
                    this.telephoneIcon = this.iconPhone;
                    break;
            }
        }
    }
}
